import { useTranslation } from 'react-i18next';
import { useOnboarding } from './OnboardingContext';

export function ProgressIndicator() {
  const { t } = useTranslation();
  const { stepIndex, totalSteps, currentStep } = useOnboarding();

  // Don't show on welcome, account-type, or success screens
  if (currentStep === 'welcome' || currentStep === 'account-type' || currentStep === 'success' || currentStep === 'corporate-success') {
    return null;
  }

  // Adjust for welcome and account-type screens (first 2 steps)
  const adjustedIndex = Math.max(0, stepIndex - 2);
  const adjustedTotal = Math.max(1, totalSteps - 1); // Exclude account-type from count
  const percentage = Math.round(((adjustedIndex + 1) / adjustedTotal) * 100);

  return (
    <div className="flex items-center justify-center gap-2 sm:gap-3 py-3 sm:py-4 px-12">
      <span className="font-display text-[11px] sm:text-xs font-bold uppercase tracking-[0.12em] text-muted-foreground whitespace-nowrap tabular-nums">
        {t('common.step', { current: adjustedIndex + 1, total: adjustedTotal })}
      </span>
      <div className="relative w-16 sm:w-24 h-1.5 bg-secondary/80 rounded-full overflow-hidden flex-shrink-0 ring-1 ring-border/40">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out shadow-glow-soft"
          style={{
            width: `${percentage}%`,
            background: 'linear-gradient(90deg, hsl(var(--accent)) 0%, hsl(var(--lime-bright)) 100%)',
          }}
        />
      </div>
      <span className="font-display text-xs sm:text-sm font-bold text-[hsl(var(--accent))] whitespace-nowrap tabular-nums">
        {percentage}%
      </span>
    </div>
  );
}
